<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { Checkbox, TextInput } from 'carbon-components-svelte';

  import type { DateCellKey, DraftEntitlementPatch, EntitlementRow, RowValidationErrors } from '../entitlements-table-types';

  const dispatch = createEventDispatcher<{
    'change-row': { rowId: string; patch: DraftEntitlementPatch };
    'toggle-is-ongoing': { rowId: string };
    'toggle-day-entitlement': { rowId: string };
  }>();

  export let row: EntitlementRow,
    cellKey: DateCellKey,
    rowValidationErrors: RowValidationErrors = {};

  const getInputValue = (event: FocusEvent): string => (event.currentTarget as HTMLInputElement | null)?.value ?? '';
  const getNullableInputValue = (event: FocusEvent): string | null => (event.currentTarget as HTMLInputElement | null)?.value || null;
  const getValidationText = (
    key: keyof RowValidationErrors,
    currentRowValidationErrors: RowValidationErrors = rowValidationErrors
  ): string => currentRowValidationErrors[key] ?? '';
</script>

{#if cellKey === 'startDate' || cellKey === 'endDate'}
  <TextInput
    hideLabel
    name={cellKey}
    labelText={row.isDayEntitlement ? 'YYYY-MM-DD' : 'YYYY-MM'}
    placeholder={row.isDayEntitlement ? 'YYYY-MM-DD' : 'YYYY-MM'}
    required
    size="sm"
    invalid={Boolean(getValidationText(cellKey, rowValidationErrors))}
    invalidText={getValidationText(cellKey, rowValidationErrors)}
    value={row[cellKey]}
    on:blur={(event) => dispatch('change-row', { rowId: row.id, patch: { [cellKey]: getInputValue(event) } })}
  />
{:else if cellKey === 'isOngoing'}
  <div class="date-wrapper">
    <Checkbox
      labelText="Ongoing"
      hideLabel
      checked={Boolean(row.isOngoing)}
      on:click={(event) => {
        event.preventDefault();
        dispatch('toggle-is-ongoing', { rowId: row.id });
      }}
      disabled={row.isDayEntitlement}
    />
    <TextInput
      inline
      hideLabel
      invalid={Boolean(getValidationText('onGoingMaxDate', rowValidationErrors))}
      invalidText={getValidationText('onGoingMaxDate', rowValidationErrors)}
      labelText="Max Date"
      placeholder={row.onGoingMaxDate ?? 'YYYY-MM'}
      disabled={!row.isOngoing}
      size="sm"
      value={row.onGoingMaxDate}
      on:blur={(event) => dispatch('change-row', { rowId: row.id, patch: { onGoingMaxDate: getInputValue(event) } })}
    />
  </div>
{:else if cellKey === 'isDayEntitlement'}
  <Checkbox
    labelText="Day Entitlement"
    hideLabel
    checked={row.isDayEntitlement}
    on:click={(event) => {
      event.preventDefault();
      dispatch('toggle-day-entitlement', { rowId: row.id });
    }}
  />
{:else if cellKey === 'expiryDate'}
  <TextInput
    hideLabel
    invalid={Boolean(getValidationText('expiryDate', rowValidationErrors))}
    invalidText={getValidationText('expiryDate', rowValidationErrors)}
    labelText="Expiry date"
    placeholder="YYYY-MM-DD"
    disabled={!row.isDayEntitlement}
    size="sm"
    value={row.expiryDate}
    on:blur={(event) => dispatch('change-row', { rowId: row.id, patch: { expiryDate: getNullableInputValue(event) } })}
  />
{/if}

<style>
  .date-wrapper {
    display: inline-flex;
    justify-content: left;
    align-items: center;
  }

  .date-wrapper :global(.bx--text-input-wrapper) {
    display: inline;
    margin-left: 0.5rem;
  }
</style>
